import { Component, EventEmitter, Output, ViewChild, OnDestroy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IonModal } from '@ionic/angular';
import { BaseComponent, Product } from '@ridango/core';

@Component({
    selector: 'rwidget-wallet-top-up-modal',
    templateUrl: './wallet-top-up-modal.component.html',
    styleUrls: ['wallet-top-up-modal.component.scss']
})
export class WalletTopUpModalComponent extends BaseComponent implements OnDestroy, OnChanges {
    @Output() amountSelected: EventEmitter<number> = new EventEmitter<number>();
    @ViewChild(IonModal) removeTopUpModal: IonModal;

    @Input() manualPriceProduct: Product | null = null;
    minAmount = 2;
    maxAmount = 50;

    amount: number = this.minAmount;

    showError = false;

    constructor() {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.manualPriceProduct && this.manualPriceProduct) {
            this.minAmount = Number(
                this.manualPriceProduct.product_properties.find((p) => p.code === 'LOAD_WALLET_MIN')?.value || 0
            );
            this.maxAmount = Number(
                this.manualPriceProduct.product_properties.find((p) => p.code === 'LOAD_WALLET_MAX')?.value || 100
            );
        }
    }

    updateFromManualPriceProduct(product: Product | null): void {
        if (product) {
            const minProperty = product.product_properties.find((p) => p.code === 'LOAD_WALLET_MIN');
            const maxProperty = product.product_properties.find((p) => p.code === 'LOAD_WALLET_MAX');

            if (minProperty?.value) {
                this.minAmount = Number(minProperty.value);
            }

            if (maxProperty?.value) {
                this.maxAmount = Number(maxProperty.value);
            }

            if (!this.amount || this.amount < this.minAmount) {
                this.amount = this.minAmount;
            }
        }
    }

    closeModal(): void {
        this.removeTopUpModal.dismiss(null, 'cancel');
    }

    openModal(): void {
        this.updateFromManualPriceProduct(this.manualPriceProduct);
        this.removeTopUpModal?.present();
    }

    setAmount(): void {
        if (this.amount < this.minAmount || this.amount > this.maxAmount) {
            this.showError = true;
            return;
        }
        this.amountSelected.emit(this.amount);
        this.closeModal();
    }

    validateInput(event: any) {
        let value = event.target.value;

        value = value.replace(/^[.,]/, '0.');
        value = value.replace(/[,]/g, '.');
        value = value.replace(/[^0-9.]/g, '');
        value = value.replace(/(\..*)\./g, '$1');
        value = value.replace(/^(\d*\.\d{2}).*$/, '$1');

        event.target.value = value;
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}
